import { DestroyRef, Injectable } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ModalTooltipService } from '@sdvor/shared/ui/v2';
import { ProductWishlistService } from '@wishlist/feature';
import { filter } from 'rxjs/operators';
import { WishlistTooltipComponent } from './wishlist-tooltip.component';

@Injectable({ providedIn: 'root' })
export class WishlistTooltipComponentService {
  constructor(
    private readonly wishlistService: ProductWishlistService,
    private readonly destroyRef: DestroyRef,
    private readonly modalTooltipService: ModalTooltipService,
  ) {}

  init(): void {
    this.wishlistService
      .getProductAdded()
      .pipe(filter(Boolean), takeUntilDestroyed(this.destroyRef))
      .subscribe((productCode) => {
        if (productCode) {
          const modalRef = this.modalTooltipService.open(WishlistTooltipComponent, {
            route: 'wishlist',
            lifeDuration: 3000,
          });
          modalRef.contentRef.setInput('productCode', productCode);
        }
      });
  }
}
